/**
 * 共通ユーティリティ関数
 * アプリケーション全体で使用される共通の関数を提供する
 */
// src/utils/common.js

/**
 * 数値フォーマットユーティリティ
 */
export const numberUtils = {
  /**
   * 数値を日本語形式でフォーマットする
   * @param {number|string} value - フォーマットする数値
   * @returns {string} フォーマットされた数値文字列
   */
  formatNumber(value) {
    if (!value || value === "" || value === null || value === undefined) {
      return "0";
    }
    if (!String(value).match(/^\d+$/)) {
      return String(value);
    }
    const formatter = new Intl.NumberFormat("ja-JP");
    return formatter.format(Number(value));
  },

  /**
   * パーセンテージをフォーマットする
   * @param {number|string} num - フォーマットする数値
   * @returns {string} フォーマットされたパーセンテージ文字列
   */
  formatPercentage(num) {
    if (num == null || num === "" || num === undefined) {
      return "";
    }
    return String(num) + "%";
  },
};

/**
 * 日付フォーマットユーティリティ
 */
export const dateUtils = {
  /**
   * 日付を日本語形式でフォーマットする
   * @param {Date|string} date - フォーマットする日付
   * @returns {string} フォーマットされた日付文字列
   */
  formatDate(date) {
    if (!date) return "";
    return new Date(date).toLocaleDateString("ja-JP");
  },

  /**
   * 現在の日付を取得する
   * @returns {string} 現在の日付文字列（YYYY-MM-DD形式）
   */
  getCurrentDate() {
    const now = new Date();
    return now.toISOString().split("T")[0];
  },
};

/**
 * バリデーションユーティリティ
 */
export const validationUtils = {
  /**
   * メールアドレスを検証する
   * @param {string} email - 検証するメールアドレス
   * @returns {boolean} 有効なメールアドレスの場合true
   */
  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  },

  /**
   * 必須項目をチェックする
   * @param {any} value - チェックする値
   * @returns {boolean} 値が存在する場合true
   */
  isRequired(value) {
    return value !== null && value !== undefined && value !== "";
  },
};

/**
 * グリッドユーティリティ
 */
export const gridUtils = {
  /**
   * グリッド行番号を生成する
   * @param {string} objid - オブジェクトID
   * @param {number} rownum - 行番号（0ベース）
   * @returns {string} 生成されたグリッド行ID
   */
  generateGridLineNum(objid, rownum) {
    return objid + (rownum + 1);
  },
};

/**
 * 文字列ユーティリティ
 */
export const stringUtils = {
  /**
   * 文字列が空かどうかをチェックする
   * @param {string} str - チェックする文字列
   * @returns {boolean} 空文字列の場合true
   */
  isEmpty(str) {
    return !str || str.trim() === "";
  },

  /**
   * 文字列をトリムする
   * @param {string} str - トリムする文字列
   * @returns {string} トリムされた文字列
   */
  trim(str) {
    return str ? str.trim() : "";
  },
};

/**
 * 配列ユーティリティ
 */
export const arrayUtils = {
  /**
   * 配列が空かどうかをチェックする
   * @param {Array} arr - チェックする配列
   * @returns {boolean} 空配列の場合true
   */
  isEmpty(arr) {
    return !arr || arr.length === 0;
  },

  /**
   * 配列から重複を除去する
   * @param {Array} arr - 重複を除去する配列
   * @returns {Array} 重複が除去された配列
   */
  unique(arr) {
    return [...new Set(arr)];
  },
};

/**
 * オブジェクトユーティリティ
 */
export const objectUtils = {
  /**
   * オブジェクトが空かどうかをチェックする
   * @param {Object} obj - チェックするオブジェクト
   * @returns {boolean} 空オブジェクトの場合true
   */
  isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
  },

  /**
   * オブジェクトの深いコピーを作成する
   * @param {Object} obj - コピーするオブジェクト
   * @returns {Object} コピーされたオブジェクト
   */
  deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
};

// デフォルトエクスポート（すべてのユーティリティを含む）
export default {
  numberUtils,
  dateUtils,
  validationUtils,
  gridUtils,
  stringUtils,
  arrayUtils,
  objectUtils,
};



// WEBPACK FOOTER //
// ./src/utils/common.js